import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import OnBoardingDataPageUI from './OnBoardingDataPageUI'

class OnBoardingDataPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      loading: true,
      onboardingData: null
    }
  }

  render() {
    return (
      <OnBoardingDataPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        loading={this.state.loading}
        onboardingData={this.state.onboardingData}
        onDownloadProvFileClick={this.handleDownloadProvisionalFile}
        onDownloadProjectFileClick={this.handleDownloadProjectFile}
        onDownloadCustomerFileClick={this.handleDownloadCustomerFile}
        onRejectLoanClick={this.handleRejectLoan}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    this.getLoan()
  }

  componentDidUpdate(prevProps, prevState) {
    const prevLoanId = prevState.loan && prevState.loan.loanId
    const currLoanId = this.state.loan && this.state.loan.loanId
    if (currLoanId && prevLoanId !== currLoanId && !this.state.onboardingData) {
      this.fetchOnboardingData(currLoanId, this.state.loan.accountId)
    }
  }

  getLoan() {
    const loanId = this.props.match.params.loanId
    const cacheManager = new CacheManager({
      resource: `/api/su/loans/${loanId}`,
      cacheKey: CacheKeys.Loan(loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(this.props.context)
  }

  getLoanCallback = (response) => {
    const loan = response.loan
    this.setState({ errorList: response.errorList, loan })
    if (loan && loan.loanId && loan.accountId) {
      this.fetchOnboardingData(loan.loanId, loan.accountId)
    } else {
      this.setState({ loading: false })
    }
  }

  fetchOnboardingData(loanId, accountId) {
    this.setState({ loading: true })
    const url = `/api/su/accounts/${accountId}/loans/${loanId}/onboardingData`
    RestApiUtils.get(
      this.props.context,
      url,
      (resp) => {
        if (resp && resp.success === 'OK') {
          this.setState({ onboardingData: resp, errorList: null, loading: false })
        } else {
          const err = (resp && resp.errorList && resp.errorList.length > 0) ? resp.errorList : ['Failed to fetch onboarding data']
          this.setState({ errorList: err, onboardingData: null, loading: false })
        }
      },
      (error) => {
        this.setState({ errorList: [error && error.message || 'Error fetching onboarding data'], onboardingData: null, loading: false })
      },
      null
    )
  }

  handleDownloadProvisionalFile = (fileName) => {
    const loan = this.state.loan
    const accountId = loan && loan.accountId
    if (!accountId || !fileName) return
    RestApiUtils.get(
      this.props.context,
      `/api/su/accounts/${accountId}/files/${encodeURIComponent(fileName)}/fileDownloadSignedUrl`,
      (response) => {
        if (response && response.errorList && response.errorList.length === 0 && response.signedUrl && response.signedUrl.signedUrl) {
          window.open(response.signedUrl.signedUrl, '_blank')
        }
      },
      null,
      null
    )
  }

  handleDownloadProjectFile = (fileName) => {
    const loanId = this.state.loan ? this.state.loan.loanId : null
    if (!loanId || !fileName) return
    RestApiUtils.get(this.props.context,
      `/api/su/loans/${loanId}/files/${encodeURIComponent(fileName)}/fileDownloadSignedUrl`,
      (response) => {
        if (response && response.errorList && response.errorList.length === 0 && response.signedUrl && response.signedUrl.signedUrl) {
          window.open(response.signedUrl.signedUrl, '_blank')
        }
      },
      null,
      null
    )
  }

  handleDownloadCustomerFile = (fileName) => {
    const loan = this.state.loan
    const loanId = loan && loan.loanId
    const accountId = loan && loan.accountId
    if (!loanId || !accountId || !fileName) return
    RestApiUtils.get(this.props.context,
      `/api/su/accounts/${accountId}/loans/${loanId}/customerFiles/${encodeURIComponent(fileName)}/fileDownloadSignedUrl`,
      (response) => {
        if (response && response.errorList && response.errorList.length === 0 && response.signedUrl && response.signedUrl.signedUrl) {
          window.open(response.signedUrl.signedUrl, '_blank')
        }
      },
      null,
      null
    )
  }

  onRefreshClick = () => {
    try {
      const loanId = this.props.match.params.loanId
      CacheManager.removeObject(CacheKeys.Loan(loanId))
    } catch (e) {
      // ignore
    }
    this.setState({ loading: true, errorList: null }, () => {
      this.getLoan()
    })
  }

  handleRejectLoan = () => {
    const loan = this.state.loan
    const loanId = loan && loan.loanId
    const accountId = loan && loan.accountId
    
    if (!loanId || !accountId) {
      this.setState({ errorList: ['Unable to determine loan or account information'] })
      return
    }

    // Show confirmation dialog
    const msg = 'Are you sure you want to reject this loan request? This action cannot be undone.'
    if (!window.confirm(msg)) {
      return
    }

    // Call the API to reject the loan
    RestApiUtils.put(
      this.props.context,
      `/api/su/accounts/${accountId}/loans/${loanId}/loanRequestRejected`,
      this.onRejectLoanCallback,
      {}
    )
  }

  onRejectLoanCallback = (response) => {
    const errorList = []
    if (response && response.errorList) {
      response.errorList.forEach(e => {
        if (e && e.message) errorList.push(e.message)
        else if (typeof e === 'string') errorList.push(e)
      })
    }

    if (errorList.length > 0) {
      this.setState({ errorList })
    } else {
      // Success - reload the page to reflect the updated status
      this.setState({ errorList: null })
      setTimeout(() => {
        this.onRefreshClick && this.onRefreshClick('noBusy')
      }, 1000)
    }
  }
}

export default withRouter(OnBoardingDataPageSF)


